const DatabaseEnum = {
  Main:"Main",
}

module.exports = {DatabaseEnum,};